import React from 'react';
import {LinedRow, Location1, Typography} from '@kaman/uikit';

export interface BranchCardProps {
    title: string;
    address: string;
    navigationLabel?: string;
    onNavigate?: () => void;
    hasBottomBorder?: boolean;
    className?: string;
}

const BranchCard = React.forwardRef<HTMLDivElement, BranchCardProps>(
    (
        {
            title,
            address,
            navigationLabel = 'مسیریابی',
            onNavigate,
            hasBottomBorder = true,
            className,
        },
        ref
    ) => {
        return (
            <div
                ref={ref}
                className={className}
                style={{
                    width: '100%',
                    minWidth: '300px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    padding: '8px',
                    paddingBottom: '12px',
                    ...(hasBottomBorder
                        ? {borderBottom: '1px solid #E5E7EB'}
                        : {}),
                }}
            >
                <LinedRow
                    hasBottomBorder={false}
                    rightSideIcon={
                        <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center">
                            <Location1 size={24} style={{color: '#0158CC'}} />
                        </div>
                    }
                    rightSideNode={
                        <Typography color="default" variant="h6">
                            {title}
                        </Typography>
                    }
                    leftSideNode={
                        <Typography
                            onClick={onNavigate}
                            color="primary"
                            className="underline underline-offset-2"
                            variant="h6"
                        >
                            {navigationLabel}
                        </Typography>
                    }
                />

                <Typography
                    color="gray"
                    className="pr-12 "
                    variant="body-small"
                >
                    {address}
                </Typography>
            </div>
        );
    }
);

BranchCard.displayName = 'BranchCard';
export default BranchCard;
